// 海コン受注配車入力一覧内の定数

export const 荷主Bindings = ["荷主コード", "荷主名", "荷主略称1", "表紙名"]

export const オーダー情報Bindings = [
  "オーダー内容",
  "オーダー備考",
  "オーダー指定時間",
  "荷主依頼番号",
]

export const コンテナ情報Bindings = [
  "コンテナNO",
  "コンテナサイズコード",
  "コンテナ軸コード",
  "コンテナサイズ名称1",
  "コンテナ軸名称1",
]

export const PICKBindings = [
  "PICK作業日",
  "PICK積卸先id",
  "PICK積卸先コード",
  "PICK積卸先名称",
  "PICK積卸先市区町村",
  "PICK付帯作業区分名称1",
  "PICK付帯作業手当",
  "PICK支払先コード",
  "PICK傭車会社名",
  "PICK運行部所コード",
  "PICK運行部所ID",
  "PICK車番",
  "PICKトレーラ車番",
  "PICK車輌配分率",
  "PICK乗務員名",
  "PICK乗務員売上額",
  "PICK海コン付帯高速料",
  "PICK工程備考",
  "PICK乗務員食事手当",
  "PICK同乗者名",
]

export const 作業Bindings = [
  "作業作業日",
  "作業積卸先id",
  "作業積卸先コード",
  "作業積卸先名称",
  "作業内容",
  "作業付帯作業区分名称1",
  "作業付帯作業手当",
  "作業運行部所コード",
  "作業支払先コード",
  "作業傭車会社名",
  "作業積卸先市区町村",
  "作業運行部所ID",
  "作業車番",
  "作業トレーラ車番",
  "作業車輌配分率",
  "作業乗務員名",
  "作業乗務員売上額",
  "作業海コン付帯高速料",
  "作業工程備考",
  "作業乗務員食事手当",
  "作業同乗者名",
]

export const 返却Bindings = [
  "返却作業日",
  "返却積卸先id",
  "返却積卸先コード",
  "返却積卸先名称",
  "返却内容",
  "返却付帯作業区分名称1",
  "返却付帯作業手当",
  "返却運行部所コード",
  "返却支払先コード",
  "返却傭車会社名",
  "返却積卸先市区町村",
  "返却運行部所ID",
  "返却車番",
  "返却トレーラ車番",
  "返却車輌配分率",
  "返却乗務員名",
  "返却乗務員売上額",
  "返却海コン付帯高速料",
  "返却工程備考",
  "返却乗務員食事手当",
  "返却同乗者名",
]

export const その他Bindings = [
  "その他作業日",
  "その他積卸先id",
  "その他積卸先コード",
  "その他積卸先名称",
  "その他内容",
  "その他付帯作業区分名称1",
  "その他付帯作業手当",
  "その他運行部所コード",
  "その他支払先コード",
  "その他傭車会社名",
  "その他積卸先市区町村",
  "その他運行部所ID",
  "その他車番",
  "その他トレーラ車番",
  "その他車輌配分率",
  "その他乗務員名",
  "その他乗務員売上額",
  "その他海コン付帯高速料",
  "その他工程備考",
  "その他乗務員食事手当",
  "その他同乗者名",
]

export const 請求Bindings = [
  "請求内訳名",
  "請求内訳コード",
  "荷主請求内訳ID",
  "請求区分コード",
  "請求数量単価",
  "請求車番",
  "履歴検索",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料税込区分コード",
  "請求高速料税込区分名称",
  "請求高速料",
  "請求合計",
  "計上基準日区分名称1",
  "date請求計上日",
  "請求備考",
]

export const 支払Bindings = [
  "支払先id",
  "支払運送料",
  "支払付帯料",
  "支払高速料",
  "支払合計",
  "date支払計上日",
  "支払備考",
]
